import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * Card — brand card component with hover lift + emerald border glow.
 * variant: elevated | flat | glass
 */
const variantClasses = {
  elevated:
    "bg-bg-card border border-white/[0.06] hover:border-brand-emerald/40 hover:shadow-card-hover",
  flat:
    "bg-white/[0.02] border border-white/[0.06] hover:border-white/12",
  glass:
    "bg-white/[0.03] border border-white/[0.08] backdrop-blur-xl hover:border-brand-emerald/40",
};

export const Card = React.forwardRef(function Card(
  {
    variant = "elevated",
    interactive = true,
    className,
    children,
    "data-testid": testId,
    ...props
  },
  ref,
) {
  return (
    <motion.div
      ref={ref}
      className={cn(
        "relative rounded-2xl p-6 transition-[border-color,box-shadow,transform,background-color] duration-300",
        variantClasses[variant],
        className,
      )}
      whileHover={interactive ? { y: -4 } : undefined}
      transition={{ type: "spring", stiffness: 300, damping: 25 }}
      data-testid={testId}
      {...props}
    >
      {children}
    </motion.div>
  );
});

export default Card;
